/* Autoplay that waits its turn.

   Three sections loop a clip as decoration - the editorial video band, the
   PLP video break and the product feature - plus the award quote. Left to
   the browser, every one of them starts on page load whether or not it is on
   screen, and a collection allowed four video breaks would decode four
   streams at once on a phone.

   So the autoplay attribute is taken off at boot and playback is driven
   here instead: a clip plays only while it is on screen, and only one plays
   at a time anywhere on the page. Without JS the attribute stays where the
   markup put it, so the clip still loops - degraded to the old behaviour
   rather than to a still frame.

   The theme's own <video-component> already does the viewport half of this
   for background videos, which is why they are not in scope here. */

(function () {
  var SELECTOR = 'video[data-oj-autoplay]';
  var current = null;

  function pauseOthers(video) {
    if (current && current !== video) {
      try { current.pause(); } catch (e) { /* torn down mid-swap */ }
    }
    current = video;
  }

  function init() {
    var videos = Array.prototype.slice.call(document.querySelectorAll(SELECTOR));
    if (!videos.length) return;

    // A reader who has asked for less motion gets the poster frame and
    // nothing else. Controls, where the section offers them, still work.
    var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    videos.forEach(function (v) {
      v.removeAttribute('autoplay');
      v.muted = true;
      v.playsInline = true;
    });

    if (still || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var v = entry.target;
          if (entry.isIntersecting) {
            // A reader who pressed pause meant it. Without this, scrolling
            // the clip off screen and back starts it again behind them.
            if (v.hasAttribute('data-oj-paused')) return;
            pauseOthers(v);
            var started = v.play();
            // Autoplay can still be refused (low power mode, for one). It is
            // decoration; the poster frame is a fine resting state.
            if (started && started.catch) started.catch(function () {});
          } else {
            v.pause();
            if (current === v) current = null;
          }
        });
      },
      { threshold: 0.25 }
    );

    videos.forEach(function (v) { observer.observe(v); });

    /* A clip that is already on screen when the observer boots can be
       missed. This section's stylesheet loads lazily, so at the moment
       observe() runs the hero still has no height - the first callback
       reports it as out of view, and with nothing scrolling afterwards
       there is no second callback to correct that. The clip then sits on
       its poster frame forever, which is exactly what a hero must not do.

       One sweep once the page has finished loading and the layout is
       real. It starts the topmost clip that is genuinely in view and
       leaves the rest to the observer. */
    function sweep() {
      for (var i = 0; i < videos.length; i++) {
        var v = videos[i];
        if (v.hasAttribute('data-oj-paused') || !v.paused) continue;
        var box = v.getBoundingClientRect();
        if (!box.height) continue;
        if (box.top < window.innerHeight && box.bottom > 0) {
          pauseOthers(v);
          var started = v.play();
          if (started && started.catch) started.catch(function () {});
          return;
        }
      }
    }

    if (document.readyState === 'complete') sweep();
    else window.addEventListener('load', sweep);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
